<script>
export let registration;


import tippy from 'sveltejs-tippy';
import dayjs from 'dayjs';


let player_name = registration.player.first_name + ' ' + registration.player.last_name;

let postdated_amount = '';
if (registration.gross_forecast !== null && registration.gross !== null) {
	postdated_amount = '$' + ((registration.gross_forecast - registration.gross)).toFixed(2);
}
// let postdated_dates = '';

console.log(registration.gross);

</script>



<style>

.registration-thumb {
	/* border... */
	/* padding */
	border: none;
	transition: all ease 0.225s;
}

.registration-thumb:hover {
	/*cursor: pointer;*/
	/*background: var(--bg-light);*/
}

</style>



<div class="panel-block registration-thumb">

	<div class="columns is-variable is-mobile is-2 is-vcentered">

		<div class="column is-3-desktop is-4-touch">
			<span>
				{player_name}
			</span>
		</div>

		<div class="column is-4-desktop is-4-touch">
			<span>
				<!-- {gross_forecast} -->
				{postdated_amount}
			</span>
		</div>

		<!-- <div class="column is-5-desktop is-4-touch">
			<span>
				{postdated_dates}
			</span>
		</div> -->

		<!-- ... -->

	</div>

</div>

